<template lang="pug">
  v-form.outlined-36(v-model="validate" d-block)
    v-layout(row align-center)
      v-flex(xs2)
        v-select(
          :items="columnOpts"
          v-model="store.column"
          label="Column"
          required
          outlined
          hide-no-data
          hide-details
          @change="doUpdate"
        )
      v-flex(xs3)
        v-text-field(
          :rules="[v => !!v || 'Item is required']"
          v-model="store.apiHotelId"
          label="Hotel ID"
          outlined
          hide-no-data
          hide-details
          @change="doUpdate"
        )
      v-flex
        v-text-field(
          :rules="[v => !!v || 'Item is required']"
          v-model="store.apiTokenId"
          label="API Key"
          outlined
          hide-no-data
          hide-details
          @change="doUpdate"
        )
      v-flex(xs1)
        v-btn(
          :disabled="!validate || syncing"
          :loading="syncing"
          color="success"
          width="100%"
          depressed
          @click="doSubmit"
        ) Sync
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    syncing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      store: {
        column: -1,
        apiHotelId: null,
        apiTokenId: null
      },
      validate: false
    }
  },
  computed: {
    columnOpts () {
      return this.headers || []
    }
  },
  methods: {
    doUpdate () {
      this.$emit('update', this.store)
    },
    doSubmit () {
      this.$emit('submit', this.store)
    }
  }
}
</script>

<style lang="stylus" scoped>
.outlined-36
  .v-select
    &.v-text-field
      &--outlined
        >>> .v-input
          &__control
            height: 36px

          &__slot
            min-height: 36px

          &__append-inner
            margin-top: 6px

        >>> .v-label
          top: auto

          &--active
            transform: translateY(-16px) scale(0.75)

  .v-text-field
    &--outlined
      >>> .v-input
        &__control
          height: 36px

        &__slot
          min-height: 36px

      >>> .v-label
        top: auto

        &--active
          transform: translateY(-16px) scale(0.75)
</style>
